import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  padding-top: 40px;
  background-image: linear-gradient(
    180deg,
    rgba(${ColorPalette.RGB.White}, 0) 0%,
    rgba(${ColorPalette.RGB.AntiFlashWhite5}, 1) 60%,
    rgba(${ColorPalette.RGB.White}, 0) 100%
  );
`;

export const Title = styled.h2`
  margin-top: auto;
  text-align: center;
  padding: 0 55px;
  font-weight: 600;
  color: ${({ theme }) => theme.responseScreen.title};
`;

export const Subtitle = styled.h5`
  margin-top: 30px;
  padding: 0 55px;
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.responseScreen.text};
`;

export const BgImage = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-top: 40px;
  background-image: url('/images/clouds.svg'), url('/images/trail.svg'),
    linear-gradient(to bottom, ${ColorPalette.HEX.White}, rgba(${ColorPalette.RGB.White}, 0));
  background-position: 0 0, center -20px, 0 70px;
  background-repeat: repeat-x, no-repeat, no-repeat;
  height: 362px;
`;
